import React from 'react'
import { Link } from 'react-router-dom'
import customRequest from '../helpers/customRequest'
import redirect from './redirect/redirect'
import message from './message/message'
import instructionsPDF from '../content/files/instructions.pdf'
import readabilityPDF from '../content/files/readability-of-stories.pdf'
import logo from '../content/images/logo.svg'

class Navbar extends React.Component
{
    render()
    {
        var {auth: user} = this.props

        var homeURL = "/"

        if (user == "customer") {
            homeURL = "/dashboard"
        }
        else if (user == "student") {
            homeURL = "/student/dashboard"
        }

        return (<nav class = "navbar navbar-light bg-light fixed-top hidden-print navbar-expand-md pl-1 pr-1 py-0">
                    <div class = "navbar-brand mx-auto">
                        <Link to = {homeURL} onClick={() => {
                            window.scrollTo(0, 0) //Lisa wants to be able to scroll to top instantly
                        }}>
                            <img
                                width = "75" height = "75"
                                src = {logo}
                                alt = "Logo"
                                title = "Home"
                            />
                        </Link>
                    </div>
                    
                    <button type="button" class="navbar-toggler collapsed" data-toggle="collapse" data-target="#navbar-collapse" aria-expanded="false">
                        <span class="sr-only">Toggle navigation</span>&#x2630;
                    </button>

                    <div class = "collapse navbar-collapse" id = "navbar-collapse"  aria-expanded="false">
                        <ul class = "nav navbar-nav">
                            <li className="nav-item">
                            {
                                user == "guest" ?
                                    <Link className="nav-link" class = "btn btn-secondary navbar-btn" to = "/account/sign-up">Sign Up</Link> : ""
                            }
                            </li>
                            { 
                                user != "student" ?
                                    <li class = "dropdown nav-item">
                                        <a class = "dropdown-toggle nav-link" data-toggle = "dropdown" href = "#">Learn More<span class = "caret"></span></a>
                                        <div class = "dropdown-menu">
                                            <Link className = "dropdown-item" to = "/about/the-program">The Program</Link>
                                            <Link className = "dropdown-item" to = "/about/testimonials">Testimonials</Link>
                                            <Link className = "dropdown-item" to = "/about/research">Research</Link>
                                            <Link className = "dropdown-item" to = "/about/use-cases">Use Cases</Link>
                                            <Link className = "dropdown-item" to = "/about/our-story">Our Story</Link>
                                        </div>
                                    </li> : ""
                            }

                            { 
                                user == "student" ?
                                <li className="nav-item">
                                    <Link className="nav-link" to = "/student/dashboard">Exercises</Link>
                                </li> : ""
                            }

                            {
                                user == "customer" ?
                                <li className="nav-item">
                                    <Link className="nav-link" to = "/students">Students</Link>
                                </li> : ""
                            }


                            <li className="nav-item">
                                <a className="nav-link" target="_blank" href = "https://tutoring.greatleaps.com/" rel = "noopener noreferrer">Find a Tutor</a>
                            </li>
                        </ul>

                        <ul class = "nav navbar-nav ml-auto">
                    {
                            user != "student" ?
                            <li className = "nav-item">
                                <Link className = "nav-link" to = "/subscribe">Pricing</Link>
                            </li> : ""
                    }
                        
                        {
                            user == "customer" ?
                            <li className = "nav-item">
                                <Link className = "nav-link" to = "/account/information">Account</Link>
                            </li> : ""
                        }
                        
                        <li class = "dropdown nav-item">
                            <a class = "dropdown-toggle nav-link" data-toggle = "dropdown" href = "#">Resources<span class = "caret"></span></a>
                            <div class = "dropdown-menu">
                                { user != "student" ? <a className = "dropdown-item" href={instructionsPDF} target = "_blank">Instructions</a> : ""}
                                { user != "student" ? <Link className = "dropdown-item" to = "/help/frequently-asked-questions">FAQ's</Link> : ""}
                                { user != "student" ? <a className = "dropdown-item" href={readabilityPDF} target = "_blank" rel = "noopener noreferrer">Readability of Stories</a> : "" }
                                <a className = "dropdown-item" href = "https://greatleaps.com/index.php?main_page=contact_us" target = "_blank" rel = "noopener noreferrer">Customer Support</a>
                                { user == "guest" ? <Link className = "dropdown-item" to = "/account/recover">Account Recovery</Link> : "" }
                            </div>
                        </li>

                        <li className = "nav-item">
                            {
                            user == "guest" ?
                            <Link id = "log-in-button" class = "btn btn-secondary navbar-btn" to = "/account/log-in/teacher">Log In</Link>
                            :
                            <form id = "log-out-form" class = "form-inline prevent-next-submit" noValidate method = "post" action = "/log-out" onSubmit={(event) =>
                            {
                                event.preventDefault()
                                customRequest.post("/api/logout")
                                .then(() =>
                                {
                                    this.props.updatePermissions()
                                    .then(() => {
                                        redirect.send("/", () => {
                                            message.success("You have successfully logged out.")
                                        })
                                    })
                                })
                            }}>
                                <button type = "submit" class = "btn btn-secondary navbar-btn">Log Out</button>
                            </form>
                            }
                        </li>
                    </ul>
                    </div>
                </nav>)
    }
}

export default Navbar
